const TIME_GRANULARITY_MAP = {
    "0": "End of Day Calculation",
    "1": "24 Hours Calculation",
};

const TERM_INTEREST_ALLOCATION_MAP = {
    "0": "Diminishing Allocation",
    "1": "Flat Allocation",
    "2": "Flat Principal",
};

const FEE_CALCULATION_MODE_MAP = {
    "1": "Original Principal",
    "2": "Outstanding Principal",
    "3": "Total Outstanding",
};

const DISBURSEMENT_TYPE_MAP = {
    "1": "Full Principal",
    "2": "Principal - Interest",
};

export const transformLoanTypeConfig = (recordData, structuredData) => {
    const loanType = recordData?.lt || recordData?.loantypes;
    if (!loanType) return {};

    const nextDescription =
        recordData?.nxt?.NextLoanDescription ?? loanType.NextLoanDescription;

    return {
        LoanType: loanType.LoanType,
        LoanDescription: loanType.LoanDescription,
        PurchaseTableId:
            recordData?.pft1?.PurchaseTableDescription ??
            loanType.PurchaseTableDescription ??
            loanType.PurchaseTableId,
        LateFeeTableId:
            recordData?.pft2?.LateFeeTableDescription ??
            loanType.LateFeeTableDescription ??
            loanType.LateFeeTableId,
        TermInterestAllocationType:
            TERM_INTEREST_ALLOCATION_MAP[loanType.TermInterestAllocationType] ??
            loanType.TermInterestAllocationType,
        TimeGranularity:
            TIME_GRANULARITY_MAP[loanType.TimeGranularity] ??
            loanType.TimeGranularity,
        DisplayOrderNumber: loanType.DisplayOrderNumber,
        FeeFixed: loanType.FeeFixed,
        FeePercentage: loanType.FeePercentage,
        FeeTax: loanType.FeeTax,
        Flagging: loanType.Flagging,
        FlaggingDays: loanType.FlaggingDays,
        FlaggingWarningDays: loanType.FlaggingWarningDays,
        GracePeriodDays: loanType.GracePeriodDays,
        IgnoreHolidays: loanType.IgnoreHolidays,
        IgnoreNextBusinessDay: loanType.IgnoreNextBusinessDay,
        IncludeFeesInEligibilityCheck: loanType.IncludeFeesInEligibilityCheck,
        IsFlaggedLoanDue: loanType.IsFlaggedLoanDue,
        MaxActiveLoans: loanType.MaxActiveLoans,
        NextLoanType: nextDescription || "N/A",
        NumberOfDays: loanType.NumberOfDays,
        NumberOfDueDays: loanType.NumberOfDueDays,
        OptIn: loanType.OptIn,
        OptOut: loanType.OptOut,
        ProductId: loanType.ProductId,
        Restrictive: loanType.Restrictive,
        SelectableByUser: loanType.SelectableByUser,
        FeeCalculationMode:
            FEE_CALCULATION_MODE_MAP[loanType.FeeCalculationMode] ??
            loanType.FeeCalculationMode,
        StopCalculatingAfterDays: loanType.StopCalculatingAfterDays,
        DisbursementType:
            DISBURSEMENT_TYPE_MAP[loanType.DisbursementType] ??
            loanType.DisbursementType,
        PaymentTerm:
            recordData?.record?.PlanDescriptions ??
            loanType.PlanDescriptions ??
            "N/a",
        structuredData,
    };
};
